import { render, staticRenderFns } from "./TotalsCodeTab.vue?vue&type=template&id=1c8eeb83"
import script from "./TotalsCodeTab.vue?vue&type=script&lang=js"
export * from "./TotalsCodeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports